import { Component } from '@angular/core';

@Component({
  selector: 'loader-shop',
  templateUrl: './loader-shop.html',
  standalone: false,
})
export class LoaderShopComponent {}
